
































import { Component, Prop, Vue } from 'vue-property-decorator';

export interface Time {
    hour: string;
    minute: string;
    second: string;
}

@Component
export default class Timer extends Vue {
    private time!: Time;
    private hourInput!: number;
    private minuteInput!: number;
    private secondInput!: number;
    private timerInterval!: number;
    private timeNum!: number;
    private hourNum!: number;
    private minuteNum!: number;
    private secondNum!: number;
    private paused!: boolean;
    private inputDisabled!: boolean;

    private data() {
        return {
            time: {hour: '00', minute: '00', second: '00'},
            hourInput: +'',
            minuteInput: +'',
            secondInput: +'',
            timerInterval: +'',
            timeNum: +'',
            hourNum: +'',
            minuteNum: +'',
            secondNum: +'',
            paused: true,
            inputDisabled: false,
        };
    }

    private startStopTimer() {
        this.paused = false;
        this.inputDisabled = true;

        if (this.time.hour === '00' && this.time.minute === '00' && this.time.second === '00') {
            this.timeNum = +(this.hourInput * 3600) + +(this.minuteInput * 60) + +this.secondInput;

            this.hourNum = this.hourInput;
            this.minuteNum = this.minuteInput;
            this.secondNum = this.secondInput;

            if (this.hourNum < 10) {
                this.time.hour = '0' + String(this.hourNum);
            } else {
                this.time.hour = String(this.hourNum);
            }

            if (this.minuteNum < 10) {
                this.time.minute = '0' + String(this.minuteNum);
            } else {
                this.time.minute = String(this.minuteNum);
            }

            if (this.secondNum < 10) {
                this.time.second = '0' + String(this.secondNum);
            } else {
                this.time.second = String(this.secondNum);
            }

            this.timeNum--;
        }
            
        this.timerInterval = setInterval(this.updateTimer, 1000) as any;
    }

    private updateTimer() {
        if (this.hourNum < 10) {
            this.time.hour = '0' + String(this.hourNum);
        } else {
            this.time.hour = String(this.hourNum);
        }

        if (this.minuteNum < 10) {
            this.time.minute = '0' + String(this.minuteNum);
        } else {
            this.time.minute = String(this.minuteNum);
        }

        if (this.secondNum < 10) {
            this.time.second = '0' + String(this.secondNum);
        } else {
            this.time.second = String(this.secondNum);
        }

        let timeInter: number;
        this.hourNum = Math.floor(this.timeNum / 3600);
        timeInter = this.timeNum - this.hourNum * 3600;
        this.minuteNum = Math.floor(timeInter / 60);
        timeInter -= this.minuteNum * 60;
        this.secondNum = timeInter;

        this.timeNum--;
        
        if (this.timeNum < -1) {
            this.stopTimer();
            const audio = new Audio('/assets/sounds/KDE-Im-Nudge.ogg');
            audio.play();
        }
    }

    private pauseTimer() {
        clearInterval(this.timerInterval);
        this.paused = true;
    }

    private stopTimer() {
        clearInterval(this.timerInterval);
        this.time = {hour: '00', minute: '00', second: '00'};
        this.paused = true;
        this.inputDisabled = false;
    }

}
